import ContactUs from './ContactUs';
import AuthComponents from './Auth';

export default function install(Vue) {
  Vue.component('ContactUs', ContactUs);
  Vue.use(AuthComponents);
}
